
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 450 300"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#006b3f","d":"M0 0h450v300H0z"}}),_c('path',{attrs:{"fill":"#fcd116","d":"M0 0h450v200H0z"}}),_c('path',{attrs:{"fill":"#ce1126","d":"M0 0h450v100H0z"}}),_c('path',{attrs:{"d":"M225 100l32.492 100-85.065-61.803h105.146L192.508 200z"}})])
          )
        }
      }
    